import { render, staticRenderFns } from "./fraude.vue?vue&type=template&id=59f87345&scoped=true&"
import script from "./fraude.vue?vue&type=script&lang=js&"
export * from "./fraude.vue?vue&type=script&lang=js&"
import style0 from "./fraude.vue?vue&type=style&index=0&id=59f87345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f87345",
  null
  
)

export default component.exports